import './VariantSelector.css';
import {useMediaQuery} from "react-responsive";

export default function VariantSelector({
                                            variant,
                                            selectedOptions,
                                            setSelectedOptions,
                                            parentIndex,
                                            isOptionSelectable
                                        }) {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    const onPick = (value) => {
        setSelectedOptions(prev =>
            prev.map((v, i) =>
                i < parentIndex ? v : i === parentIndex ? value : "" // clear downstream
            )
        );
    };

    const Option = ({ value,color }) => {
        const selectable = isOptionSelectable(parentIndex, value);
        const isSelected = selectedOptions[parentIndex] === value;
        const cls = [
            'variant-selector-option',
            !selectable ? 'variant-disabled' : '',
            isSelected ? 'selected-option' : ''
        ].join(' ').trim();
        const commonProps = {
            className: cls,
            'aria-disabled': !selectable,
            role: 'button',
            tabIndex: selectable ? 0 : -1,
            onClick: selectable ? () => onPick(value) : undefined,
            onKeyDown: (e) => {
                if (!selectable) return;
                if (e.key === 'Enter' || e.key === ' ') onPick(value);
            }
        };

        const hasLabel = /^.+\s+#[^\s]+$/.test(value);

        return (
            <div {...commonProps} style={{backgroundColor: color !== "" && !hasLabel ? color : ""}}>
                {hasLabel
                    ? <>
                        <span className="option-selector-color-circle" style={{backgroundColor: color}} />
                        <span>{value.replace(/#[^\s]+/, "").trim()}</span>
                    </>
                    : color !== "" ? "" : value
                }
            </div>
        );
    };

    const getColor = (value) => {
        const match = value.match(/#[^\s]+/);
        return match ? match[0] : value;
    };

    return (
        <div className="variant-selector-container">
            <div className="variant-selector-label">{variant.label}</div>
            {isMobile ? <div className={'variant-selector-wrapper'}>{(variant.options || []).map((option, idx) => (
                <Option key={idx} value={option.value} color={variant.label==="kolor" ? getColor(option.value) : ""} />
            ))}</div> : (variant.options || []).map((option, idx) => (

                <Option key={idx} value={option.value} color={variant.label==="kolor" ? getColor(option.value) : ""}/>
            ))}
        </div>
    );
}
